// Enhanced MenuSvg with smooth animations
const MenuSvg = ({ openNavigation }) => {
    return (
      <svg
        className="overflow-visible"
        width="24"
        height="18"
        viewBox="0 0 24 18"
      >
        <rect
          className="transition-all duration-300 origin-center ease-out"
          y={openNavigation ? "8" : "0"}
          width="24"
          height="2.5"
          rx="1.25"
          fill="currentColor"
          transform={`rotate(${openNavigation ? "45" : "0"})`}
        />
        <rect
          className={`transition-all duration-300 origin-center ease-out ${
            openNavigation ? "opacity-0 scale-0" : "opacity-100 scale-100"
          }`}
          y="8"
          width="24"
          height="2.5"
          rx="1.25"
          fill="currentColor"
        />
        <rect
          className="transition-all duration-300 origin-center ease-out"
          y={openNavigation ? "8" : "16"}
          width="24"
          height="2.5"
          rx="1.25"
          fill="currentColor"
          transform={`rotate(${openNavigation ? "-45" : "0"})`}
        />
      </svg>
    );
  };
  
  // Enhanced Background with shipping theme
const ShippingRoutes = () => {
    return (
      <div className="absolute inset-0 overflow-hidden">
        {/* Animated wave background */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-blue-100 to-indigo-100">
          <div className="absolute inset-0 opacity-30">
            <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
              <path
                d="M0,20 Q25,10 50,20 T100,20 L100,100 L0,100 Z"
                fill="url(#wave1)"
                className="animate-pulse"
              />
              <path
                d="M0,40 Q25,30 50,40 T100,40 L100,100 L0,100 Z"
                fill="url(#wave2)"
                className="animate-pulse"
                style={{ animationDelay: '1s' }}
              />
              <defs>
                <linearGradient id="wave1" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="rgba(59, 130, 246, 0.3)" />
                  <stop offset="100%" stopColor="rgba(147, 197, 253, 0.1)" />
                </linearGradient>
                <linearGradient id="wave2" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="rgba(99, 102, 241, 0.2)" />
                  <stop offset="100%" stopColor="rgba(165, 180, 252, 0.1)" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>
        
        {/* Floating shipping icons */}
        <div className="absolute top-10 left-8 animate-bounce" style={{ animationDelay: '0s', animationDuration: '3s' }}>
          <div className="w-8 h-8 bg-gradient-to-br from-blue-400 to-blue-600 rounded-lg shadow-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
            </svg>
          </div>
        </div>
        
        <div className="absolute top-32 right-12 animate-bounce" style={{ animationDelay: '1s', animationDuration: '3s' }}>
          <div className="w-10 h-6 bg-gradient-to-br from-green-400 to-green-600 rounded-lg shadow-lg flex items-center justify-center">
            <svg className="w-6 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.293l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13a1 1 0 102 0V9.414l1.293 1.293a1 1 0 001.414-1.414z" clipRule="evenodd" />
            </svg>
          </div>
        </div>
        
        <div className="absolute bottom-32 left-12 animate-bounce" style={{ animationDelay: '2s', animationDuration: '3s' }}>
          <div className="w-8 h-8 bg-gradient-to-br from-purple-400 to-purple-600 rounded-full shadow-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
            </svg>
          </div>
        </div>
        
        {/* Connecting lines with animation */}
        <svg className="absolute inset-0 w-full h-full opacity-20">
          <defs>
            <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#3B82F6" />
              <stop offset="100%" stopColor="#8B5CF6" />
            </linearGradient>
          </defs>
          <path
            d="M50 80 Q120 120 200 80 T350 80"
            stroke="url(#lineGradient)"
            strokeWidth="2"
            fill="none"
            strokeDasharray="5,5"
            className="animate-pulse"
          />
          <path
            d="M80 200 Q150 160 220 200 T380 200"
            stroke="url(#lineGradient)"
            strokeWidth="2"
            fill="none"
            strokeDasharray="5,5"
            className="animate-pulse"
            style={{ animationDelay: '1.5s' }}
          />
        </svg>
      </div>
    );
  };
  
  // Enhanced HamburgerMenu with better styling
const HamburgerMenu = () => {
    return (
      <div className="absolute inset-0 pointer-events-none lg:hidden">
        <ShippingRoutes />
        
        {/* Overlay gradient */}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/80 to-white/90"></div>
        
        {/* Bottom accent */}
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-blue-500"></div>
      </div>
    );
  };
  
  // Enhanced Header component (replace the nav section in your original code)
const EnhancedMobileNav = ({ openNavigation, navigation, handleClick, isScrolled }) => {
    return (
      <nav
        className={`${
          openNavigation ? "flex" : "hidden"
        } fixed top-[5rem] left-0 right-0 bottom-0 bg-white lg:static lg:flex lg:mx-auto lg:bg-transparent transition-all duration-300 ease-out`}
      >
        {/* Mobile Navigation Content */}
        <div className="relative z-10 flex flex-col items-center justify-center m-auto lg:flex-row w-full">
          {navigation.map((item, index) => (
            <a
              key={item.id}
              href={item.url}
              onClick={handleClick}
              className={`
                group block cursor-pointer relative font-medium text-xl uppercase 
                transition-all duration-300 ease-out hover:text-blue-600 
                ${item.onlyMobile ? "lg:hidden" : ""} 
                px-8 py-6 md:py-8 lg:-mr-0.25 lg:text-xs lg:font-semibold 
                ${isScrolled ? "text-gray-800" : "text-blue-600"} 
                xl:px-12 transform hover:scale-105 hover:-translate-y-1
                ${openNavigation ? 'animate-fadeInUp' : ''}
              `}
              style={{
                animationDelay: openNavigation ? `${index * 0.1}s` : '0s'
              }}
            >
              {/* Background hover effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10 scale-95 group-hover:scale-100"></div>
              
              {/* Icon for each nav item */}
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-gradient-to-br from-blue-400 to-purple-500 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-300 transform group-hover:scale-110"></div>
                <span className="relative">
                  {item.title}
                  {/* Underline effect */}
                  <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-blue-500 to-purple-500 group-hover:w-full transition-all duration-300"></div>
                </span>
              </div>
            </a>
          ))}
          
          {/* Mobile CTA Button */}
          <div className="mt-8 lg:hidden">
            <a
              href="#login"
              onClick={handleClick}
              className="relative inline-flex items-center justify-center px-8 py-4 overflow-hidden font-semibold text-white transition-all duration-300 bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl group hover:from-blue-600 hover:to-purple-700 shadow-lg hover:shadow-xl transform hover:scale-105"
            >
              <span className="absolute top-0 right-0 inline-block w-4 h-4 transition-all duration-500 ease-in-out bg-blue-700 rounded group-hover:-mr-4 group-hover:-mt-4">
                <span className="absolute top-0 right-0 w-5 h-5 rotate-45 translate-x-1/2 -translate-y-1/2 bg-white"></span>
              </span>
              <span className="relative text-lg">Get Started Today</span>
            </a>
          </div>
        </div>
  
        <HamburgerMenu />
      </nav>
    );
  };
  

  
  // Integration example - Replace the nav section in your Header component with this:
  const IntegratedHeaderNav = ({ 
    openNavigation, 
    navigation, 
    handleClick, 
    isScrolled, 
    toggleNavigation 
  }) => {
    return (
      <>
        {/* Replace your existing nav section with this */}
        <nav
          className={`${
            openNavigation ? "flex" : "hidden"
          } fixed top-[5rem] left-0 right-0 bottom-0 bg-white lg:static lg:flex lg:mx-auto lg:bg-transparent transition-all duration-300 ease-out z-40`}
        >
          <div className="relative z-10 flex flex-col items-center justify-center m-auto lg:flex-row w-full">
            {navigation.map((item, index) => (
              <a
                key={item.id}
                href={item.url}
                onClick={handleClick}
                className={`
                  group block cursor-pointer relative font-medium text-xl uppercase 
                  transition-all duration-300 ease-out hover:text-blue-600 
                  ${item.onlyMobile ? "lg:hidden" : ""} 
                  px-8 py-6 md:py-8 lg:-mr-0.25 lg:text-xs lg:font-semibold 
                  ${isScrolled ? "text-gray-800" : "text-blue-600"} 
                  xl:px-12 transform hover:scale-105 hover:-translate-y-1
                  ${openNavigation ? 'animate-fadeInUp' : ''}
                `}
                style={{
                  animationDelay: openNavigation ? `${index * 0.1}s` : '0s'
                }}
              >
                <div className="absolute inset-0 bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10 scale-95 group-hover:scale-100"></div>
                
                <div className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-gradient-to-br from-blue-400 to-purple-500 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-300 transform group-hover:scale-110"></div>
                  <span className="relative">
                    {item.title}
                    <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-blue-500 to-purple-500 group-hover:w-full transition-all duration-300"></div>
                  </span>
                </div>
              </a>
            ))}
            
            <div className="mt-8 lg:hidden">
              <a
                href="#login"
                onClick={handleClick}
                className="relative inline-flex items-center justify-center px-8 py-4 overflow-hidden font-semibold text-white transition-all duration-300 bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl group hover:from-blue-600 hover:to-purple-700 shadow-lg hover:shadow-xl transform hover:scale-105"
              >
                <span className="absolute top-0 right-0 inline-block w-4 h-4 transition-all duration-500 ease-in-out bg-blue-700 rounded group-hover:-mr-4 group-hover:-mt-4">
                  <span className="absolute top-0 right-0 w-5 h-5 rotate-45 translate-x-1/2 -translate-y-1/2 bg-white"></span>
                </span>
                <span className="relative text-lg">Get Started Today</span>
              </a>
            </div>
          </div>
  
          <HamburgerMenu />
        </nav>
  
        {/* Enhanced mobile menu button */}
        <button
          className="ml-auto lg:hidden mobile-menu-btn"
          onClick={toggleNavigation}
          aria-label="Toggle navigation"
        >
          <MenuSvg openNavigation={openNavigation} />
        </button>
      </>
    );
  };
  
  export { MenuSvg, ShippingRoutes, HamburgerMenu, IntegratedHeaderNav };